import React from 'react';
import PropTypes from 'prop-types';
import { VariableSizeGrid as Grid } from 'react-window';
import PerfectScrollbar from 'perfect-scrollbar';
import * as deepmerge from 'deepmerge';
import { withSize } from 'react-sizeme';
//widgets
import withStyles from '@material-ui/core/styles/withStyles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
//local
import { CardBody, CardHeader, CardFooter, Chip } from '../';
import { Loading } from '../Loading';
import { Card } from '@material-ui/core';
import Toolbar from './tgToolbar.jsx';

const loadingMessages = ['Loading, please wait…'];

class tgTable extends React.Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.gridRef = React.createRef();
    this.headerRef = React.createRef();
  }

  state = {
    columns: [],
    cols: [],
    tableWidth: 0,
    tableHeight: 0,
    sortBy: null,
    sortAsc: true,
    searchText: '',
    selectedRows: [],
  };

  componentDidMount() {
    const prevOnScroll = this.gridRef.current._onScroll.bind({});
    this.gridRef.current._onScroll = (event) => {
      this.handleScroll(event, prevOnScroll);
    };
    if (navigator.platform.indexOf('Win') > -1) {
      new PerfectScrollbar(this.gridRef.current._outerRef);
    }
    this.resizeTable();
    window.addEventListener('resize', this.resizeTable);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeTable);
  }

  UNSAFE_componentWillMount() {
    this.getDefaultOptions(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !this.isEqual(this.props.data, nextProps.data) ||
      !this.isEqual(this.props.columns, nextProps.columns) ||
      !this.isEqual(this.props.options, nextProps.options)
    ) {
      this.getDefaultOptions(nextProps);
    }
  }

  isEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  getDefaultOptions(props, firstTime) {
    const defaultOptions = {
      sort: true,
      search: true,
      download: true,
      colSelect: true,
      filter: true,
    };

    this.options = { ...defaultOptions, ...props.options };

    const defaultColumnOptions = {
      hide: {
        display: false,
        download: false,
        colSelect: false,
        filter: false,
        sort: false,
      },
    };

    const columns = props.columns.map((column) => {
      let col = deepmerge({ filters: [] }, column);
      if (col.options && col.options.hide === true) {
        col.options.hide = {};
        Object.keys(defaultColumnOptions.hide).forEach(
          (key) => (col.options.hide[key] = true)
        );
      } else if (col.options && Array.isArray(col.options.hide)) {
        col.options.hide = col.options.hide.reduce((obj, v) => {
          obj[v] = true;
          return obj;
        }, {});
      }
      col.options = { ...defaultColumnOptions, ...col.options };
      return col;
    });
    const shownCols = this.getColWidths(
      columns.filter((col) => !col.options.hide.display),
      props.data,
      this.options.onRowSelect
    );

    const data = props.data.filter(this.filter(columns));
    const sortby = props.columns.filter(
      (column) => column.options && column.options.sort
    )[0];
    const sorted = {
      sortBy: sortby ? sortby.key : this.state.sortBy,
      sortAsc: sortby ? sortby.options.sort !== 'desc' : this.state.sortAsc,
    };
    if (sortby && sortby.key)
      this.sort(data, sorted.sortBy, sorted.sortAsc, true);

    if (this.gridRef.current)
      this.gridRef.current.resetAfterColumnIndex(0, false);

    this.setState({
      shownData: data,
      columns: columns,
      shownCols: shownCols,
      sortBy: sorted.sortBy,
      sortAsc: sorted.sortAsc,
      tableWidth: this.getTableWidth(shownCols),
      selectedRows: props.selectedRows
        ? props.selectedRows
        : this.state.selectedRows,
    });
  }

  updateColumn = (column, index) => {
    let columns = this.state.columns.slice();
    columns[index] = column;
    const shownCols = this.getColWidths(
      columns.filter((col) => !col.options.hide.display),
      this.props.data,
      this.props.options.onRowSelect,
      true
    );

    this.gridRef.current.resetAfterColumnIndex(0, false);
    this.setState({
      columns: columns,
      shownCols: shownCols,
      tableWidth: this.getTableWidth(shownCols),
    });
  };

  getColWidths = (cols, data, selectableRows, forceUpdate) => {
    const shownCols = cols.slice();
    if (shownCols[0].accWidth === undefined || forceUpdate) {
      const autoWidth = shownCols.reduce(
        (acc, col, index) =>
          acc.concat(
            !col.width ? deepmerge({ originalIndex: index }, col) : []
          ),
        []
      );
      if (autoWidth.length) {
        data.forEach((objData) => {
          autoWidth.forEach((col, index) => {
            const val = objData[col.key]
              ? this.getText(objData, col).length
              : 0;
            if (
              (shownCols[col.originalIndex].width || 0) <
              (val < col.name.length ? col.name.length : val) * 6 + 100
            ) {
              shownCols[col.originalIndex].width =
                (val < col.name.length ? col.name.length : val) * 6 + 100;
            }
          });
        });
      }
      if (selectableRows) {
        shownCols[0].width += 50;
      }
      let accWidth = 0;
      shownCols.forEach((col, index) => {
        if (!col.width)
          col.width =
            (col.name ? col.name.length : 1) * 6 + 100 + (index === 0 ? 50 : 0);
        col.accWidth = accWidth;
        accWidth += col.width;
      });
    }
    return shownCols;
  };

  sort = (data, key, asc, delayState) => {
    if (!data.length) return data;
    if (key === this.state.sortBy && !delayState) {
      data.reverse();
      this.setState({
        sortAsc: !this.state.sortAsc,
      });
    } else {
      data.sort(
        (a, b) =>
          (a[key] && typeof a[key].localeCompare === 'function'
            ? a[key].localeCompare(b[key], undefined, {
                sensitivity: 'base',
                numeric: true,
              })
            : b[key] && typeof b[key].localeCompare === 'function'
            ? -b[key].localeCompare(a[key], undefined, {
                sensitivity: 'base',
                numeric: true,
              })
            : a[key] - b[key]) * (asc ? 1 : -1)
      );
      return delayState
        ? data
        : this.setState({
            sortBy: key,
            sortAsc: asc,
          });
    }
  };

  getTableWidth = (shownCols) => {
    const maxWidth = this.props.size.width - 40;
    const lastCol = shownCols[shownCols.length - 1];
    const tableWidth = lastCol.accWidth + lastCol.width;
    return tableWidth < maxWidth ? tableWidth : maxWidth;
  };

  resizeTable = () => {
    setTimeout(() => {
      const width = this.getTableWidth(this.state.shownCols);
      if (width && this.containerRef.current) {
        const height = this.containerRef.current.clientHeight;
        const outerRef = this.gridRef.current._outerRef;
        this.setState(
          {
            tableWidth: width,
            tableHeight: height,
          },
          () => {
            if (height < outerRef.scrollTop) outerRef.scrollTop = 0;
          }
        );
      }
    }, 100);
  };

  handleScroll(event, prevOnScroll) {
    prevOnScroll(event);
    this.headerRef.current.scrollLeft = event.target.scrollLeft;
  }

  getText = (data, col) => {
    const value =
      typeof col.options.customValue === 'function'
        ? col.options.customValue(data[col.key], data)
        : data[col.key];
    return value && value.toString ? value.toString() : '';
  };

  filter = (columns) => (data) => {
    const cols = columns.filter((col) => col.filters.length);
    for (let i = 0; i < cols.length; i++) {
      const regex = new RegExp(cols[i].filters.join('|').toLowerCase());
      if (!regex.test(this.getText(data, cols[i]).toLowerCase())) return false;
    }
    return true;
  };

  updateFilter = (columnIndex, filterArray) => {
    const columns = this.state.columns.slice();
    columns[columnIndex].filters = filterArray;
    const shownCols = this.getColWidths(
      columns.filter((col) => !col.options.hide.display),
      this.props.data,
      this.props.options.onRowSelect
    );

    this.setState(
      {
        shownData: this.state.sortBy
          ? this.sort(
              this.props.data.filter(this.filter(columns)),
              this.state.sortBy,
              this.state.sortAsc,
              true
            )
          : this.props.data.filter(this.filter(columns)),
        columns: columns,
        shownCols: shownCols,
      },
      this.resizeTable
    );
  };

  search = (columns, searchText) => (data) => {
    if (searchText) {
      let text = searchText;
      if (text.indexOf(',') !== -1) {
        text =
          '^' +
          text[0] +
          text.slice(1, text.length - 1).replace(/,(\s)?/g, '$|^') +
          text[text.length - 1] +
          '$';
        text = text.replace(/,(\s)?/g, '');
      }
      if (!text || text === '^$') return true;
      text = new RegExp(text, 'gi');
      for (let i = 0; i < columns.length; i++) {
        if (text.test(this.getText(data, columns[i]))) return true;
      }
    } else {
      return true;
    }
    return false;
  };

  updateSearch = (searchText) => {
    this.setState({
      shownData: this.props.data
        .filter(this.filter(this.state.columns))
        .filter(this.search(this.state.shownCols, searchText)),
      searchText: searchText,
    });
  };

  rowSelect = (rowIndex, checked) => {
    const selectedRows = this.state.selectedRows.slice();
    if (checked) {
      selectedRows.push(rowIndex);
    } else {
      const index = selectedRows.indexOf(rowIndex);
      if (index !== -1) selectedRows.splice(index, 1);
    }
    this.setState({
      selectedRows: selectedRows,
    });
    if (typeof this.props.options.onRowSelect === 'function')
      this.props.options.onRowSelect(
        selectedRows.map((rowIndex) => this.state.shownData[rowIndex])
      );
  };

  rowSelectAll = (event) => {
    const changedRows = event.target.checked
      ? [...this.state.shownData.keys()]
      : [];
    this.setState({
      selectedRows: changedRows,
    });
    if (typeof this.props.options.onRowSelect === 'function')
      this.props.options.onRowSelect(
        event.target.checked ? this.state.shownData.slice() : []
      );
  };

  cellUpdate = (column, rowIndex) => (value) => {
    let data = this.state.shownData;
    data[rowIndex][column.key] = value;
    this.setState({
      shownData: data
        .filter(this.filter(this.state.columns))
        .filter(this.search(this.state.shownCols, this.state.searchText)),
    });
    return data[rowIndex];
  };

  renderData = (column, rowIndex, data) => {
    return typeof column.options.customRender === 'function'
      ? column.options.customRender(
          column.key,
          data,
          this.state.shownData[rowIndex],
          this.cellUpdate(column, rowIndex)
        )
      : typeof column.options.customValue === 'function'
      ? column.options.customValue(data, this.state.shownData[rowIndex])
      : data;
  };

  renderCell = ({ columnIndex, rowIndex, style }) => {
    const column = this.state.shownCols[columnIndex];
    const classes = this.props.classes;
    const checked = this.state.selectedRows.indexOf(rowIndex) !== -1;
    const selectable = this.props.options.onRowSelect;
    const rowClick = this.props.options.rowClick;
    return (
      <div
        style={
          typeof this.props.options.styleFunc === 'function'
            ? Object.assign(
                this.props.options.styleFunc(
                  this.state.shownData[rowIndex],
                  column
                ),
                style
              )
            : style
        }
        className={
          `${classes.cellWrapper}` +
          (checked ? ` ${classes.cellSelected}` : ``) +
          (rowClick || selectable ? ` ${classes.cellSelectable}` : ``)
        }
        onClick={
          rowClick
            ? (event) => rowClick(this.state.shownData[rowIndex])
            : selectable
            ? (event) => this.rowSelect(rowIndex, !checked)
            : null
        }
      >
        {columnIndex === 0 && selectable ? (
          <TableCell
            component="div"
            className={classes.checkboxCell}
            style={{ height: style.height }}
            padding="checkbox"
          >
            <Checkbox
              color="primary"
              onClick={(event) =>
                this.rowSelect(rowIndex, event.target.checked)
              }
              checked={checked}
            />
          </TableCell>
        ) : null}
        <TableCell
          component="div"
          className={
            `${classes.cell}` +
            (column.align === 'right' ? ` ${classes.cellRight}` : ``) +
            (column.align === 'left' ? ` ${classes.cellLeft}` : ``)
          }
          style={{ height: style.height }}
        >
          {this.renderData(
            column,
            rowIndex,
            this.state.shownData[rowIndex][column.key]
          )}
        </TableCell>
      </div>
    );
  };

  render() {
    const {
      classes,
      title,
      titleColor,
      renderTitle,
      data,
      options,
      actions,
      footer,
      loading,
    } = this.props;
    const {
      columns,
      shownCols,
      shownData,
      sortBy,
      sortAsc,
      searchText,
      tableWidth,
      tableHeight,
      selectedRows,
    } = this.state;

    return (
      <div className={classes.root}>
        <Card className={classes.card} style={{ width: tableWidth + 40 }}>
          <CardHeader
            color={titleColor}
            plain={titleColor === undefined}
            className={classes.cardHeader}
          >
            {selectedRows.length ? (
              <div className={classes.selectedToolbar}>
                <div className={classes.selectedMainText}>
                  <strong>{selectedRows.length} row(s) selected</strong>
                </div>
                <div className={classes.selectAction}>
                  {options.selectAction}
                </div>
              </div>
            ) : (
              <Toolbar
                title={title}
                renderTitle={renderTitle}
                data={data}
                shownData={shownData}
                columns={columns}
                options={this.options}
                searchText={searchText}
                updateColumn={this.updateColumn}
                updateFilter={this.updateFilter}
                updateSearch={this.updateSearch}
              />
            )}
          </CardHeader>
          <CardBody className={classes.cardBody}>
            <div className={classes.chipArray}>
              {columns
                .filter((col) => col.filters.length)
                .map((col) => (
                  <Chip
                    key={col.key}
                    label={col.name + ': ' + col.filters}
                    onDelete={() => this.updateFilter(columns.indexOf(col), [])}
                    className={classes.chip}
                  />
                ))}
            </div>
            {actions}
            <div className={classes.tableRoot}>
              <div
                className={classes.headerScroll}
                ref={this.headerRef}
                style={{ width: tableWidth }}
              >
                <TableHead component="div" className={classes.header}>
                  {shownCols.map((col, index) => (
                    <div
                      key={index}
                      style={{
                        width: col.width,
                        left: col.accWidth,
                      }}
                      className={`${classes.cellWrapper} ${classes.headerWrapper}`}
                    >
                      {!index && options.onRowSelect ? (
                        <TableCell
                          component="div"
                          className={`${classes.checkboxCell} ${classes.headerCell}`}
                          padding="checkbox"
                        >
                          <Checkbox
                            color="primary"
                            onClick={this.rowSelectAll}
                            checked={
                              selectedRows.length > 0 &&
                              selectedRows.length === shownData.length
                            }
                          />
                        </TableCell>
                      ) : null}
                      <TableCell
                        component="div"
                        className={`${classes.cell} ${classes.headerCell}`}
                      >
                        {col.options.hide.sort ? (
                          col.name
                        ) : (
                          <Tooltip
                            title="Sort"
                            placement={'bottom-start'}
                            enterDelay={300}
                          >
                            <TableSortLabel
                              active={col.key === sortBy}
                              direction={sortAsc ? 'asc' : 'desc'}
                              onClick={() => this.sort(shownData, col.key)}
                            >
                              {col.name}
                            </TableSortLabel>
                          </Tooltip>
                        )}
                      </TableCell>
                    </div>
                  ))}
                </TableHead>
              </div>
              <div className={classes.gridContainer} ref={this.containerRef}>
                {!shownData.length ? (
                  <TableCell
                    component="div"
                    style={{ width: tableWidth }}
                    className={classes.emptyText}
                  >
                    {loading ? (
                      <div>
                        {
                          loadingMessages[
                            (loadingMessages.length * Math.random()) | 0
                          ]
                        }
                        <Loading spinnerOnly />
                      </div>
                    ) : (
                      options.emptyText || 'Sorry, no matching records found'
                    )}
                  </TableCell>
                ) : null}
                <Grid
                  columnCount={shownCols.length}
                  columnWidth={(index) => shownCols[index].width}
                  height={tableHeight}
                  width={tableWidth}
                  rowCount={shownData.length}
                  rowHeight={(index) => 42}
                  estimatedRowHeight={42}
                  ref={this.gridRef}
                >
                  {this.renderCell}
                </Grid>
              </div>
            </div>
          </CardBody>
          {footer || !options.hideRowCount ? (
            <CardFooter className={classes.cardFooter}>
              {!options.hideRowCount ? (
                <div className={classes.footer}>
                  {shownData.length + ' Rows'}
                </div>
              ) : null}
              {footer ? (
                <div className={classes.footer} style={{ textAlign: 'right' }}>
                  {footer}
                </div>
              ) : null}
            </CardFooter>
          ) : null}
        </Card>
      </div>
    );
  }
}

tgTable.defaultProps = {
  options: {},
  loading: false,
};

tgTable.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.oneOf([
    'primary',
    'info',
    'success',
    'warning',
    'danger',
    'rose',
  ]),
  renderTitle: PropTypes.node,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      width: PropTypes.number,
      options: PropTypes.shape({
        sort: PropTypes.oneOf(['asc', 'desc']),
        hide: PropTypes.oneOfType([
          PropTypes.bool,
          PropTypes.arrayOf(
            PropTypes.oneOf([
              'display',
              'download',
              'colSelect',
              'filter',
              'sort',
            ])
          ),
        ]),
        customRender: PropTypes.func,
        customValue: PropTypes.func,
      }),
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  options: PropTypes.shape({
    sort: PropTypes.bool,
    search: PropTypes.bool,
    download: PropTypes.bool,
    colSelect: PropTypes.bool,
    filter: PropTypes.bool,
    onRowsSelect: PropTypes.func,
    selectAction: PropTypes.node,
    rowClick: PropTypes.func,
    emptyText: PropTypes.string,
    styleFunc: PropTypes.func,
    hideRowCount: PropTypes.bool,
  }),
  actions: PropTypes.node,
  footer: PropTypes.node,
  loading: PropTypes.bool,
};

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '95%',
  },
  card: {
    position: 'relative',
    height: '100%',
    maxWidth: '100%',
    margin: '0 auto',
  },
  cardHeader: {},
  selectedToolbar: {
    minHeight: '48px',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#ccc',
    borderRadius: '3px',
  },
  selectedMainText: {
    flex: '1 1 auto',
    color: '#333',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
    },
  },
  selectAction: {
    flex: '1 1 auto',
    textAlign: 'center',
    color: '#ff0000',
    fontSize: '0.8rem',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right',
    },
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 0,
    overflow: 'hidden',
    height: '75%',
  },
  cardFooter: {
    position: 'absolute',
    bottom: 0,
    padding: 15,
    margin: 'auto',
    width: '100%',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.background.paper,
  },
  tableRoot: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  chipArray: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  gridContainer: {
    flex: 1,
    overflow: 'hidden',
    ...theme.typography.body2,
  },
  headerScroll: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flex: '0 0 auto',
    height: '48px',
  },
  header: {
    display: 'inline-flex',
    position: 'relative',
    width: '100%',
    height: '48px',
  },
  headerWrapper: {
    height: '48px',
    position: 'absolute',
    top: 0,
  },
  headerCell: {
    height: '48px',
  },
  cellWrapper: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  cellSelectable: {
    cursor: 'pointer',
  },
  cellSelected: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  checkboxCell: {
    display: 'inline-flex',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    width: '50px',
  },
  cell: {
    display: 'inline-flex',
    flex: 1,
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  cellRight: {
    justifyContent: 'flex-end',
  },
  cellLeft: {
    justifyContent: 'flex-start',
  },
  emptyText: {
    textAlign: 'center',
    padding: theme.spacing(1) + 'px 0 ' + theme.spacing(1) + 'px 0',
  },
  footer: {
    alignSelf: 'flex-start',
  },
});

export default withSize()(withStyles(styles)(tgTable));
